import * as React from 'react';
import { useCallback, useEffect, useRef, useState } from 'react';
import cn from 'classnames';
import { FareFeaturePaymentType } from '@websky/graphql';
import { useTheme } from '../../../../../../../theme';
import { WithTooltip } from '@shared/ui';
const GridOption = ({ className, variant, optionIcon, paymentIcon, paymentType, optionType, title, tooltip }) => {
    const { GridOption: css } = useTheme('Entities').FareGroupV2;
    const [tooltipOpen, setTooltipOpen] = useState(false);
    const containerRef = useRef(null);
    const handleTouchStart = useCallback(() => {
        setTooltipOpen(true);
    }, []);
    useEffect(() => {
        if (!tooltipOpen) {
            return undefined;
        }
        const handleOutsideTouch = (e) => {
            if (containerRef.current && !containerRef.current.contains(e.target)) {
                setTooltipOpen(false);
            }
        };
        document.addEventListener('touchstart', handleOutsideTouch);
        return () => document.removeEventListener('touchstart', handleOutsideTouch);
    }, [tooltipOpen]);
    const showTitle = Boolean(paymentType === FareFeaturePaymentType.Free && title);
    const paymentIconElement = React.createElement("div", { className: css.paymentIcon }, paymentIcon);
    const titleElement = React.createElement("div", { className: css.title }, title);
    return (React.createElement(WithTooltip, { title: tooltip, open: tooltip ? tooltipOpen : false, onOpen: () => setTooltipOpen(true), onClose: () => setTooltipOpen(false), disableTouchListener: true },
        React.createElement("div", { "data-option-type": optionType, className: cn(css.root, css[variant], className, {
                [css.pay]: paymentType === FareFeaturePaymentType.Pay,
                [css.free]: paymentType === FareFeaturePaymentType.Free,
                [css.notAvailable]: paymentType === FareFeaturePaymentType.NotAvailable,
                [css.withTooltip]: !!tooltip
            }), ref: containerRef, onTouchStart: handleTouchStart },
            React.createElement("div", { className: css.optionIcon }, optionIcon),
            variant === 'small' && React.createElement(React.Fragment, null, showTitle ? titleElement : paymentIconElement),
            variant === 'big' && (React.createElement(React.Fragment, null,
                paymentIconElement,
                titleElement)))));
};
export default GridOption;
